import { connect } from 'react-redux';
import { unpublishTesScores } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  unpublishTesScores,
};

function ModalUnpublishScore({ unpublishTesScores, data, closeModal }) {
  const auth = data?.auth;
  const item = data?.item;
  const id = data?.id;
  const history = data?.history;
  const screenWidth = useScreenWidth();

  function handleUnpublish() {
    unpublishTesScores({
      auth,
      history,
      id,
      values: item,
    });
    closeModal();
  }

  return (
    <Modal
      variant='info'
      label='Unpublish'
      closeModal={closeModal}
      width={screenWidth > 600 ? 600 : screenWidth}
    >
      <div className='flex justify-around flex-column align-start mx-5 mb-5'>
        <p className='is-size-6 mt-5 mb-3'>
          Apakah Anda yakin untuk meng-unpublish score siswa?
        </p>
      </div>
      <div className='flex justify-end align-center px-4'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={() => handleUnpublish(data)} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalUnpublishScore);
